// Module
var code = "<template class=\"a-fieldset__root\"> <fieldset> <legend class=\"a-fieldset__legend\" textcontent.bind=\"title\"></legend> <slot></slot> </fieldset> </template> ";
// Exports
export default code;